var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { color_random } from "./Functions";
var FrecuencyTable = /** @class */ (function () {
    function FrecuencyTable(data) {
        this.parts = 6;
        this.niveles = [];
        this.data = this.descomponer(data);
        this.calculate();
    }
    FrecuencyTable.prototype.descomponer = function (data, kp, index) {
        var _this = this;
        if (kp === void 0) { kp = ""; }
        if (index === void 0) { index = 0; }
        var nobj = {};
        Object.keys(data).map(function (key) {
            var elm = data[key];
            if (!_this.niveles[index])
                _this.niveles[index] = [];
            var indexEncontrado = _this.niveles[index].findIndex(function (a) { return a == key; });
            if (indexEncontrado <= -1) {
                _this.niveles[index].push(key);
            }
            if (typeof elm == "number") {
                nobj[kp + key] = elm;
            }
            else {
                nobj = __assign(__assign({}, nobj), _this.descomponer(elm, kp + key + "-", index + 1));
            }
        });
        return nobj;
    };
    FrecuencyTable.prototype.print = function () {
        console.log("intervals", this.intervals);
        console.log("frequency", this.frequency);
        console.log("relative_frequency", this.relative_frequency);
        console.log("acumulated_frequency", this.acumulated_frequency);
        console.log("acumulated_relative_frequency", this.acumulated_relative_frequency);
    };
    FrecuencyTable.prototype.min = function (arrName) {
        var arr = this[arrName];
        if (Array.isArray(arr) && arr.every(function (item) { return typeof item == 'number'; }))
            return Math.min.apply(Math, arr);
        return 0;
    };
    FrecuencyTable.prototype.max = function (arrName) {
        var arr = this[arrName];
        if (Array.isArray(arr) && arr.every(function (item) { return typeof item == 'number'; }))
            return Math.max.apply(Math, arr);
        return 0;
    };
    FrecuencyTable.prototype.sum = function (arrName) {
        var arr = this[arrName];
        if (Array.isArray(arr) && arr.every(function (item) { return typeof item === 'number'; }))
            return arr.reduce(function (a, b) { return a + b; }, 0);
        return 0;
    };
    FrecuencyTable.prototype.sumABS = function (arrName) {
        var arr = this[arrName];
        if (Array.isArray(arr) && arr.every(function (item) { return typeof item === 'number'; }))
            return arr.reduce(function (a, b) { return Math.abs(a) + Math.abs(b); }, 0);
        return 0;
    };
    FrecuencyTable.prototype.calculate = function () {
        this.calc_intervals();
        this.calc_intervals_color();
        // Diferencia entre el maximo y el
        this.calc_frequency_data();
        this.calc_range();
        this.calc_scale();
        this.calc_frequency();
        this.calc_relative_frequency();
        this.calc_relative_frequency_scaled();
        this.calc_acumulated_frequency();
        this.calc_acumulated_relative_frequency();
    };
    FrecuencyTable.prototype.calc_intervals = function () {
        this.intervals = Object.keys(this.data);
    };
    FrecuencyTable.prototype.calc_intervals_color = function () {
        this.intervals_color = this.intervals.map(function (a) { return color_random(); });
    };
    FrecuencyTable.prototype.calc_range = function () {
        var min = this.min("frequency_data");
        if (min > 0) {
            min = 0;
        }
        var max = (this.max("frequency_data") - (min));
        // const min = this.min("frequency_data");
        this.range_min = min;
        this.range = max;
    };
    FrecuencyTable.prototype.calc_scale = function () {
        this.scale = Math.round((this.range / 0.90) / this.parts);
    };
    FrecuencyTable.prototype.calc_frequency_data = function () {
        this.frequency_data = Object.values(this.data);
    };
    FrecuencyTable.prototype.calc_frequency = function () {
        var max = this.max("frequency_data");
        var min = this.min("frequency_data");
        var ajuste = 0;
        if (min < 0) {
            ajuste = min * -1;
        }
        this.frequency = Object.values(this.data).map(function (a) {
            return a + ajuste;
        });
    };
    FrecuencyTable.prototype.calc_relative_frequency = function () {
        // const total_frequency = this.sumABS("frequency");
        var total_frequency = this.sum("frequency");
        // const total_frequency = this.max("frequency") - this.min("frequency")
        this.relative_frequency = this.frequency.map(function (f) { return f / total_frequency; });
    };
    FrecuencyTable.prototype.calc_relative_frequency_scaled = function () {
        // const total_frequency = this.sumABS("frequency");
        var total_frequency = this.parts * this.scale;
        // const total_frequency = this.max("frequency") - this.min("frequency")
        this.relative_frequency_scaled = this.frequency.map(function (f) { return f / total_frequency; });
    };
    FrecuencyTable.prototype.calc_acumulated_frequency = function () {
        var acum = 0;
        this.acumulated_frequency = this.frequency.map(function (f) {
            var fa = f + acum;
            acum += f;
            return fa;
        });
    };
    FrecuencyTable.prototype.calc_acumulated_relative_frequency = function () {
        var total_frequency = this.sum("frequency");
        this.acumulated_relative_frequency = this.acumulated_frequency.map(function (f) { return f / total_frequency; });
    };
    return FrecuencyTable;
}());
export default FrecuencyTable;
